export interface ProjectExportObject{
    projectGuid: string,
    assetGuids: string[],
    workOrderGuids?: string[],
}

export interface OptionsObject {
    projectExportObjectList: ProjectExportObject[],
    jobOptions: {
        addresses: string[],
        videoFileNameScheme: string,
        pacp: boolean,
        macp: boolean,
        pdf: boolean,
        db: boolean,
        csv,
        videos: boolean,
        photos: boolean,
        counterIPD: boolean,
        ignoreValidation: boolean,
        ignoreValidationMessage: boolean,
        exportWorkOrders: boolean,
        exportInspections: boolean,
        exportType?: string,
    }
}

// eslint-disable-next-line no-shadow
export enum TableMode {
    NORMAL = 0,
    EDIT = 1,
    EXPORT = 2,
    CREATE = 3,
}

// eslint-disable-next-line no-shadow
export enum ExportType {
    PDF = 'PDF',
    DB = 'DB',
    CSV = 'CSV',
}

// eslint-disable-next-line no-shadow
export enum CsvExportType {
    NASSCO_FIELDS = 'NASSCO Fields',
    CUSTOMER_PREP = 'Customer Prep',
    Asset = 'Asset',
    ASSET_OVERVIEW = 'Asset Overview',
}

// eslint-disable-next-line no-shadow
export enum MediaType {
    VIDEOS = 'Videos',
    COUNTER_IPD = 'Counter (IPD)',
    PHOTOS = 'Photos',
}

export interface ExportOptionValue {
  name: string;
  disabled: boolean;
  value: any;
}

export interface ExportOptionsSection {
  visible: boolean;
  options?: ExportOptionValue[];
}

export interface ExportOptions{
  exportTypeCheckboxes?: ExportOptionsSection,
  mediaTypeCheckboxes?: ExportOptionsSection,
  validationOptionsSection?: ExportOptionsSection;
  csvExportTypeOptions?: CsvExportType[],
}
